"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSpecificitiesValuesToFormDataOfRegisterForm = exports.default = exports.ICONS = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _formik = require("formik");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _Translations = require("react-platform-components/dist/Translations");
var _bs = require("react-icons/bs");
var _si = require("react-icons/si");
var _im = require("react-icons/im");
var _useDidUpdateEffect = require("react-platform-components/dist/hooks/useDidUpdateEffect");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ICONS = {
  "snapchat": /*#__PURE__*/_react.default.createElement(_bs.BsSnapchat, null),
  "whatsapp": /*#__PURE__*/_react.default.createElement(_bs.BsWhatsapp, null),
  "messenger": /*#__PURE__*/_react.default.createElement(_bs.BsMessenger, null),
  "skype": /*#__PURE__*/_react.default.createElement(_bs.BsSkype, null),
  "telegram": /*#__PURE__*/_react.default.createElement(_bs.BsTelegram, null),
  "null": /*#__PURE__*/_react.default.createElement(_bs.BsTelephone, null),
  "wechat": /*#__PURE__*/_react.default.createElement(_si.SiWechat, null),
  "viber": /*#__PURE__*/_react.default.createElement(_si.SiViber, null),
  "hangouts": /*#__PURE__*/_react.default.createElement(_im.ImHangouts, null)
};
exports.ICONS = ICONS;
var CategoryOfStoreField = null;
try {
  CategoryOfStoreField = require('react-platform-category-of-store/dist/CategoryOfStore/CategoryOfStoreField').default;
} catch (error) {
  console.log('errror categori of store');
}
var DefaultContainer = function DefaultContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    style: {
      marginTop: 35
    }
  }, children);
};

/**
 * We use this for set sepcificites values to form data, we use it in register only, it use application/json as content type.
 * @param {Object} values the all values of the form
 * @param {String} fieldName the name of the seecificities data
 */
var setSpecificitiesValuesToFormDataOfRegisterForm = function setSpecificitiesValuesToFormDataOfRegisterForm(values) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "store_specificities";
  var data = {};
  if (values.specificities && !_lodash.default.isEmpty(values.specificities)) {
    values.specificities.forEach(function (item, index) {
      if (item.choice) {
        data["".concat(fieldName, "-").concat(index, "-specificity")] = item.specificity.id;
        if (item.specificity.type === "date") {
          data["".concat(fieldName, "-").concat(index, "-date")] = moment(item.choice, "DD-MM-YYYY").format("YYYY-MM-DD");
        } else if (item.specificity.type === "m_list") {
          data["".concat(fieldName, "-").concat(index, "-choices")] = item.choice.join("|");
        } else if (item.specificity.type === "free") {
          data["".concat(fieldName, "-").concat(index, "-free")] = item.choice;
        } else if (item.specificity.type === "number") {
          data["".concat(fieldName, "-").concat(index, "-number")] = item.choice;
        } else if (item.specificity.type === "range") {
          data["".concat(fieldName, "-").concat(index, "-range_min")] = item.choice[0];
          data["".concat(fieldName, "-").concat(index, "-range_max")] = item.choice[1];
        } else if (item.specificity.type === "boolean") {
          data["".concat(fieldName, "-").concat(index, "-boolchoice")] = item.choice;
        } else if (item.specificity.type === "phone") {
          data["".concat(fieldName, "-").concat(index, "-phone")] = item.choice;
        } else if (item.specificity.type === "link") {
          data["".concat(fieldName, "-").concat(index, "-link")] = item.choice;
        } else if (item.specificity.type === "document") {
          throw Error('The send files in register not implemented yet.');
        } else {
          data["".concat(fieldName, "-").concat(index, "-choice")] = item.choice;
        }
      }
    });
  }
  return data;
};
exports.setSpecificitiesValuesToFormDataOfRegisterForm = setSpecificitiesValuesToFormDataOfRegisterForm;
function SpecificitiesOfStoreFields(props) {
  var displayFieldCondition = props.displayFieldCondition,
    showSpecificitiesTitle = props.showSpecificitiesTitle;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var specificities = (0, _reactRedux.useSelector)(function (state) {
    return state.specificityOfStoreReducer.specificities;
  });
  var categories = (0, _reactRedux.useSelector)(function (state) {
    return state.categoryOfStoreReducer ? state.categoryOfStoreReducer.categories : null;
  });
  (0, _useDidUpdateEffect.useDidUpdateEffect)(function () {
    console.log("UPdate categories");
    if (CategoryOfStoreField && values.category !== "") {
      addSpecificities();
    } else {
      if (CategoryOfStoreField && values.category !== "" && !_lodash.default.isEmpty(values.specificities)) {
        var _values$specificities;
        if (((_values$specificities = values.specificities[0].category) === null || _values$specificities === void 0 ? void 0 : _values$specificities.id) !== values.category) {
          addSpecificities();
        }
      } else {
        if (CategoryOfStoreField && values.category !== "" && _lodash.default.isEmpty(values.specificities)) {
          addSpecificities();
        }
      }
    }
  }, [values.category]);
  var addSpecificities = function addSpecificities() {
    var _selectedCategory$dee;
    // // Find selected category
    var selectedCategory = categories.find(function (item) {
      return item.id == _lodash.default.get(values, 'category');
    });
    // Loop through deep_category_specificities param of the selected category
    // and add each category to the specificities form field
    setFieldValue("specificities", _lodash.default.without(selectedCategory === null || selectedCategory === void 0 ? void 0 : (_selectedCategory$dee = selectedCategory.deep_category_specificities) === null || _selectedCategory$dee === void 0 ? void 0 : _selectedCategory$dee.map(function (item) {
      var _props$store;
      var specificity = _lodash.default.find(specificities, {
        id: item.specificity.id
      });
      if (!displayFieldCondition(specificity)) return null;
      return _objectSpread(_objectSpread(_objectSpread({}, item), _lodash.default.find((_props$store = props.store) === null || _props$store === void 0 ? void 0 : _props$store.store_specificities, function (specificity) {
        return specificity.specificity.id === item.specificity.id;
      })), {}, {
        specificity: specificity
      });
    }), null));
  };
  if (_lodash.default.isEmpty(values.specificities) || CategoryOfStoreField && !_lodash.default.get(values, 'category')) return null;
  if (CategoryOfStoreField) {
    if (!_lodash.default.get(values, 'category') || !values.specificities || _lodash.default.isEmpty(values.specificities)) {
      // hide this fieds if the category is not selected yet
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
      name: "specificities",
      render: function render(arrayHelpers) {
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          container: true,
          item: true,
          xs: 12,
          alignItems: "center"
        }, showSpecificitiesTitle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
          variant: "subtitle1",
          className: "pl-2",
          style: {
            fontSize: '1.1rem',
            color: '#908f8f'
          }
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Specificities"
        }))), specificities && specificities.length > 0 && values.specificities && values.specificities.map(function (item, index) {
          var specificity = specificities.filter(function (option) {
            return Number(option.id) === Number(item.specificity.id);
          })[0];
          return /*#__PURE__*/_react.default.createElement(_core.Grid, {
            item: true,
            xs: 12,
            key: index
          }, specificity.type === 'list' ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
            variant: "outlined",
            fullWidth: true,
            required: item.required,
            label: specificity.name,
            name: "specificities[".concat(index, "].choice"),
            margin: "normal",
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
            },
            value: values.specificities[index].choice || '',
            validate: item.required ? (0, _formValidators.required)() : function () {}
          }, specificity.choices && specificity.choices.map(function (choice) {
            return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
              key: choice.value,
              value: choice.value
            }, choice.label);
          })) : specificity.type === 'date' ? /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
            name: "specificities[".concat(index, "].choice"),
            value: values.specificities[index].choice || '',
            label: specificity.name,
            margin: "normal",
            variant: "outlined",
            fullWidth: true,
            type: "date",
            required: item.required,
            validate: item.required ? (0, _formValidators.required)() : function () {},
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
            },
            InputLabelProps: {
              shrink: true
            }
          }) : specificity.type === 'free' ? /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
            name: "specificities[".concat(index, "].choice"),
            value: values.specificities[index].choice || '',
            label: specificity.name,
            margin: "normal",
            variant: "outlined",
            fullWidth: true,
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
            },
            required: item.required,
            validate: item.required ? (0, _formValidators.required)() : function () {}
          }) : specificity.type === 'phone' ? /*#__PURE__*/_react.default.createElement(_formFields.PhoneNumber, {
            name: "specificities[".concat(index, "].choice"),
            label: specificity.name,
            variant: "outlined",
            margin: "normal",
            country: specificity.default_country,
            disableAreaCodes: true,
            fullWidth: true,
            required: specificity.required,
            InputProps: {
              endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
                position: "end"
              }, ICONS[specificity.phone_number_type])
            }
          }) : specificity.type === 'm_list' ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
            variant: "outlined",
            fullWidth: true,
            margin: "normal",
            required: item.required,
            value: values.specificities[index].choice || [],
            label: specificity.name,
            name: "specificities[".concat(index, "].choice"),
            validate: item.required ? (0, _formValidators.required)() : function () {},
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
            },
            renderValue: function renderValue(selected) {
              var value = specificity.choices && specificity.choices.filter(function (choice) {
                return selected.some(function (value) {
                  return value === choice.value;
                });
              }).map(function (choice) {
                return choice.label;
              }).join(', ').slice(0, 45);
              value += value.length === 45 ? '...' : '';
              return value;
            },
            multiple: true
          }, specificity.choices && specificity.choices.map(function (_ref2) {
            var _values$specificities2, _values$specificities3;
            var label = _ref2.label,
              value = _ref2.value;
            return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
              key: value,
              value: value
            }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
              checked: !!((_values$specificities2 = values.specificities[index]) !== null && _values$specificities2 !== void 0 && (_values$specificities3 = _values$specificities2.choice) !== null && _values$specificities3 !== void 0 && _values$specificities3.includes(value))
            }), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
              primary: label
            }));
          })) : specificity.type === 'link' ? /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
            name: "specificities[".concat(index, "].choice"),
            value: values.specificities[index].choice || '',
            label: specificity.name,
            margin: "normal",
            variant: "outlined",
            fullWidth: true,
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
            },
            required: item.required,
            validate: item.required ? (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.url)()]) : (0, _formValidators.url)()
          }) : null);
        }));
      }
    });
  } else {
    var Container = props.container || DefaultContainer;
    return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
      name: "specificities",
      render: function render(arrayHelpers) {
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          container: true,
          item: true,
          xs: 12,
          alignItems: "center"
        }, showSpecificitiesTitle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
          variant: "subtitle1",
          className: "pl-2",
          style: {
            fontSize: '1.1rem',
            color: '#908f8f'
          }
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Specificities"
        }))), specificities && specificities.length > 0 && specificities.map(function (specificity, index) {
          var _values$specificities4, _values$specificities5, _values$specificities6, _values$specificities7, _values$specificities10;
          return /*#__PURE__*/_react.default.createElement(_core.Grid, {
            item: true,
            xs: 12,
            key: index
          }, specificity.type === 'list' ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
            variant: "outlined",
            fullWidth: true,
            label: specificity.name,
            name: "specificities[".concat(index, "].choice"),
            margin: "normal",
            value: values.specificities ? values === null || values === void 0 ? void 0 : (_values$specificities4 = values.specificities[index]) === null || _values$specificities4 === void 0 ? void 0 : _values$specificities4.choice : '',
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
              setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
              setFieldValue("specificities.".concat(index, ".type"), specificity.type);
            }
          }, specificity.choices && specificity.choices.map(function (choice) {
            return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
              key: choice.value,
              value: choice.value
            }, choice.label);
          })) : specificity.type === 'date' ? /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
            name: "specificities[".concat(index, "].choice"),
            value: values.specificities ? values === null || values === void 0 ? void 0 : (_values$specificities5 = values.specificities[index]) === null || _values$specificities5 === void 0 ? void 0 : _values$specificities5.choice : '',
            label: specificity.name,
            margin: "normal",
            variant: "outlined",
            fullWidth: true,
            type: "date",
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
              setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
              setFieldValue("specificities.".concat(index, ".type"), specificity.type);
            },
            InputLabelProps: {
              shrink: true
            }
          }) : specificity.type === 'free' ? /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
            name: "specificities[".concat(index, "].choice"),
            value: values.specificities ? values === null || values === void 0 ? void 0 : (_values$specificities6 = values.specificities[index]) === null || _values$specificities6 === void 0 ? void 0 : _values$specificities6.choice : '',
            label: specificity.name,
            margin: "normal",
            variant: "outlined",
            fullWidth: true,
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
              setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
              setFieldValue("specificities.".concat(index, ".type"), specificity.type);
            }
          }) : specificity.type === 'phone' ? /*#__PURE__*/_react.default.createElement(_formFields.PhoneNumber, {
            name: "specificities[".concat(index, "].choice"),
            label: specificity.name,
            variant: "outlined",
            margin: "normal",
            country: specificity.default_country,
            disableAreaCodes: true,
            fullWidth: true,
            required: specificity.required,
            InputProps: {
              endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
                position: "end"
              }, ICONS[specificity.phone_number_type])
            }
          }) : specificity.type === 'm_list' ? /*#__PURE__*/_react.default.createElement(_formFields.Select, {
            variant: "outlined",
            fullWidth: true,
            margin: "normal",
            value: values.specificities ? values === null || values === void 0 ? void 0 : (_values$specificities7 = values.specificities[index]) === null || _values$specificities7 === void 0 ? void 0 : _values$specificities7.choice : '',
            label: specificity.name,
            name: "specificities[".concat(index, "].choice"),
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
              setFieldValue("specificities.".concat(index, ".specificity.id"), specificity.id);
              setFieldValue("specificities.".concat(index, ".type"), specificity.type);
            },
            renderValue: function renderValue(selected) {
              var value = specificity.choices && specificity.choices.filter(function (choice) {
                return selected.some(function (value) {
                  return value === choice.value;
                });
              }).map(function (choice) {
                return choice.label;
              }).join(', ').slice(0, 45);
              value += value.length === 45 ? '...' : '';
              return value;
            },
            multiple: true
          }, specificity.choices && specificity.choices.map(function (_ref3) {
            var _values$specificities8, _values$specificities9;
            var label = _ref3.label,
              value = _ref3.value;
            return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
              key: value,
              value: value
            }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
              checked: !!((_values$specificities8 = values.specificities[index]) !== null && _values$specificities8 !== void 0 && (_values$specificities9 = _values$specificities8.choice) !== null && _values$specificities9 !== void 0 && _values$specificities9.includes(value))
            }), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
              primary: label
            }));
          })) : specificity.type === 'link' ? /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
            name: "specificities[".concat(index, "].choice"),
            value: values.specificities ? values === null || values === void 0 ? void 0 : (_values$specificities10 = values.specificities[index]) === null || _values$specificities10 === void 0 ? void 0 : _values$specificities10.choice : '',
            label: specificity.name,
            margin: "normal",
            variant: "outlined",
            fullWidth: true,
            onChange: function onChange(event) {
              setFieldValue("specificities.".concat(index, ".choice"), event.target.value);
            },
            required: specificity.required,
            validate: specificity.required ? (0, _formValidators.validators)([(0, _formValidators.required)(), (0, _formValidators.url)()]) : (0, _formValidators.url)()
          }) : null);
        }));
      }
    }));
  }
}
var _default = SpecificitiesOfStoreFields;
exports.default = _default;